import React from "react";

import { Box, useTheme } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const SubscriptionLoader: React.FC = () => {
  const theme = useTheme();
  return (
    <>
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginBottom={theme.spacing(0.5)}
      >
        <Skeleton variant="text" height={32} width={200} />
        <Skeleton variant="text" height={24} width={156} />
      </Box>
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Skeleton variant="text" height={48} width={200} />
          <Skeleton variant="text" height={24} width={156} />
        </Box>
        <Skeleton
          variant="rectangular"
          width={200}
          height={36}
          style={{ borderRadius: 24 }}
        />
      </Box>
    </>
  );
};

export default SubscriptionLoader;
